<template>
  <div class="person pt-[20px]">
    <div class="mx-[15px] flex justify-center items-center flex-col">
      <div v-if="IS_DOUBLE_WALLET">
        <div class="personheader w-full relative px-[6px]">
          <div class="flex">
            <div class="avatar p-[8px] w-[76px] h-[78px] flex-shrink-0 mt-[6px]">
              <img :src="VITE_IMG_URL + userStore.userInfo.avatar" alt=""
                class="w-[58px] h-[58px] rounded-full cursor-pointer" @click="showAvatarModal = true">
            </div>

            <div class="ml-[11px] flex items-center flex-wrap">
              <div class="flex items-center w-full">
                <div class="color-[#009683] text-[13px]">{{ t('person.id') }}:</div>
                <div class="color-[#ffffff] text-[13px] ml-[6px]">{{ userStore.userInfo.userId }}</div>
                <img :src="getAssetsFile('home/yonoCopyed.png')" alt="" class="w-[12px] h-[12px] ml-[5px]"
                  @click="copyUserId(userStore.userInfo.userId)">
                <!-- 使用vipStore的方式获取VIP图标 -->
                <img v-if="vipStore.vipInfo?.currentVip?.icon" :src="VITE_IMG_URL + vipStore.vipInfo.currentVip.icon"
                  alt="" class="w-auto h-[20px] ml-[10px] object-cover ">
              </div>
              <div class="flex items-center mt-[5px]">
                <div class="color-[#009683] text-[13px] w-full">{{ t('person.account') }}:</div>
                <div class="color-[#ffffff] text-[13px] ml-[6px]">{{ userStore.userInfo.nickname }}</div>
              </div>

              <div class="flex items-center mt-[5px] w-full font-bold">
                <div class="flex items-center w-full">
                  <div class="color-[#ffffff] text-[20px]">{{ displayBalance }}</div>
                  <div class="color-[#ffffff] text-[20px] ml-[6px]">{{ VITE_symbol }}</div>
                  <img :src="getAssetsFile('home/shuax.png')" alt="" class="w-[24px] h-[24px] ml-[10px]"
                    :class="{ 'rotate-animation': isRefreshing }" @click="handleRefresh" style="cursor:pointer">
                </div>
              </div>
            </div>
            <!-- 第26行，用盒子包住邮箱图标和红点 -->
            <div class="absolute right-[1px] top-[-0px]">
              <img :src="getAssetsFile('home/email1@2x.png')" alt="" class="w-[25.5px] h-[25.5px]"
                @click="goToMensagens(1)">
              <!-- 邮箱红点 -->
              <RedDot v-if="messageStore.count > 0" class="absolute top-[2px] right-[2px]" :count="messageStore.count"
                :big="messageStore.count > 10" />

            </div>
          </div>
        </div>
        <div class="flex items-center justify-between mt-[15px] w-full px-[6px]">
          <Button type="vip" class="!w-[160.8px] !h-[48.5px] !text-[15px]" @click="handleWithdraw">
            <img :src="getAssetsFile('SVG/withdraw.svg')" alt="" class="w-[23px] h-[19px] ">
            <div class="ml-[9px]">{{ t('person.withdraw') }}</div>
          </Button>
          <Button type="vip" class="!w-[160.8px] !h-[48.5px] !text-[15px]" :warning="true" @click="handleDeposit">
            <img :src="getAssetsFile('home/recharge@2x.png')" alt="" class="w-[23px] h-[19px] ">
            <div class="ml-[9px]">{{ t('person.deposit') }}</div>
          </Button>
        </div>
      </div>
      <div v-if="!IS_DOUBLE_WALLET" class="w-full">
        <div class="personheader w-full relative px-[6px]">
          <div class="flex">
            <div class="avatar p-[8px] w-[63px] h-[65.5px] flex-shrink-0 mt-[6px]">
              <img :src="VITE_IMG_URL + userStore.userInfo.avatar" alt=""
                class="w-[47px] h-[47px] rounded-full cursor-pointer" @click="showAvatarModal = true">
            </div>

            <div class="ml-[8px] flex items-center flex-wrap">
              <div class="w-full flex justify-between flex-wrap">
                <div class="flex items-center w-full">
                  <div class="flex items-center w-full">
                    <div class="color-[#009683] text-[13px]">{{ t('person.id') }}:</div>
                    <div class="color-[#ffffff] text-[13px] ml-[2px]">{{ userStore.userInfo.userId }}</div>
                    <img :src="getAssetsFile('home/yonoCopyed.png')" alt="" class="w-[12px] h-[12px] ml-[5px]"
                      @click="copyUserId(userStore.userInfo.userId)">
                    <!-- 使用vipStore的方式获取VIP图标 -->
                    <img v-if="vipStore.vipInfo?.currentVip?.icon"
                      :src="VITE_IMG_URL + vipStore.vipInfo.currentVip.icon" alt=""
                      class="w-auto h-[20px] ml-[10px] object-cover ">
                  </div>
                  <div class="flex items-center">
                    <img @click="handleRefresh" class="w-[25.5px] h-[25.5px] mr-[11.5px] cursor-pointer"
                      :class="{ 'rotate-animation-reverse': isRefreshing }" :src="getAssetsFile('person/refresh.png')"
                      alt="">
                    <!-- 第26行，用盒子包住邮箱图标和红点 -->
                    <div class="mr-[7px] flex relative">

                      <img :src="getAssetsFile('home/email1@2x.png')" alt="" class="w-[25.5px] h-[25.5px]"
                        @click="goToMensagens(1)">
                      <!-- 邮箱红点 -->
                      <RedDot v-if="messageStore.count > 0" class="absolute top-[2px] right-[2px]"
                        :count="messageStore.count" :big="messageStore.count > 10" />
                    </div>
                  </div>

                </div>
                <div class="flex items-center mt-[6px] w-full">
                  <div class="color-[#009683] text-[13px] ">{{ t('person.account') }}:</div>
                  <div class="color-[#ffffff] text-[13px] ml-[2px]">{{ userStore.userInfo.nickname }}</div>
                </div>
              </div>


              <div v-if="IS_DOUBLE_WALLET" class="flex items-center w-full font-bold">
                <div class="flex items-center w-full">
                  <div class="color-[#ffffff] text-[20px]">{{ displayBalance }}</div>
                  <div class="color-[#ffffff] text-[20px] ml-[6px]">{{ VITE_symbol }}</div>
                  <img :src="getAssetsFile('home/shuax.png')" alt="" class="w-[24px] h-[24px] ml-[10px]"
                    :class="{ 'rotate-animation': isRefreshing }" @click="handleRefresh" style="cursor:pointer">
                </div>
              </div>
            </div>

          </div>
          <div class="person-content mt-[11.5px] px-[8px] py-[18.5px] flex">
            <div class="w-[70%] flex">
              <div class="w-[54%] relative">
                <div class="w-full h-full pl-[14px]">
                  <div class="h-2/5 flex items-center">
                    <img :src="getAssetsFile('person/CASH.png')" alt="" class="w-[auto] h-[12px]">
                  </div>
                  <div style="
              text-shadow: 
              0px -2px 2px #00242B,
              0px 2px 2px #00242B,
              2px 0px 2px #00242B,
              -2px 0px 2px #00242B;
              color:aliceblue
              " :class="{ 'text-[14px]': cash > 9999999, 'text-[16px]': cash > 999999 }"
                    class="h-3/5 w-full flex items-center  font-bold text-[18px] w-full overflow-hidden text-ellipsis whitespace-nowrap">
                    {{ numberFormat(cash) }}
                  </div>
                </div>
                <div class="bg-[#009683] w-[1px] h-full absolute right-0 top-0"></div>
              </div>
              <div class="w-[46%]">
                <div class="w-full h-full pl-[14px]">
                  <div class="h-2/5 flex items-center">
                    <img :src="getAssetsFile('person/Bonus.png')" alt="" class="w-[auto] h-[12px]" />
                    <img :src="getAssetsFile('home/bonusInfoRecardor.png')" @click="goToBonusRecord"
                      class="w-[12px] h-[13px] ml-[5px] cursor-pointer" />
                  </div>
                  <div style="
                text-shadow: 
                0px -2px 2px #00242B,
                0px 2px 2px #00242B,
                2px 0px 2px #00242B,
                -2px 0px 2px #00242B;
                color:aliceblue"
                    class="h-3/5 flex items-center  font-bold text-[18px] w-full overflow-hidden text-ellipsis whitespace-nowrap"
                    :class="{ 'text-[14px]': bonus > 9999999, 'text-[16px]': bonus > 999999 }">
                    {{ numberFormat(bonus) }}
                  </div>
                </div>


              </div>
            </div>
            <div class="w-[30%]">
              <div class="w-full px-[6px]">
                <Button type="vip" class="!w-[90.6px] !h-[24.15px] !text-[9.27px]" @click="handleWithdraw">
                  <div class="flex items-center w-full px-[10px]">
                    <img :src="getAssetsFile('SVG/withdraw.svg')" alt="" class="w-[15px] h-[12.5px] flex-shrink-0">
                    <div class="ml-[9px] w-full">{{ t('person.withdraw') }}</div>
                  </div>

                </Button>
                <Button type="vip" class="!w-[90.6px] !h-[24.15px] !text-[9.27px]" :warning="true"
                  @click="handleDeposit">
                  <div class="flex items-center w-full px-[10px]">
                    <img :src="getAssetsFile('home/recharge@2x.png')" alt="" class="w-[15px] h-[12.5px] flex-shrink-0">
                    <div class="ml-[9px] w-full">{{ t('person.deposit') }}</div>
                  </div>
                </Button>
              </div>

            </div>
          </div>

        </div>



      </div>

      <div class="vipstyle w-full relative flex" @click="goToVip">
        <!-- VIP红点 -->
        <!-- <div v-if="hasVipRewards" class="vip-badge-dot"></div> -->
        <RedDot v-if="hasVipRewards" class="absolute top-15px right-15px" />

        <div class="flex w-full">
          <div class="flex-shrink-0 flex items-center justify-between ">
            <div class="flex items-center justify-center w-[60px] h-[60px]">
              <!-- 使用vipStore的方式获取VIP图标 -->
              <img v-if="vipStore.vipInfo?.currentVip?.icon" :src="VITE_IMG_URL + vipStore.vipInfo.currentVip.icon"
                alt="" class="max-w-full max-h-full w-auto h-auto">

            </div>
          </div>
          <div class="w-full px-[10px] flex items-center flex-wrap">
            <div class="flex w-full">
              <div class="text-[11px] color-[#ffffff] ">
                <!-- 根据是否为最高等级显示不同文本 -->
                <template v-if="isMaxLevel">
                  <span class="color-[#FEF64A] mx-[2px]">VIP{{ vipStore.vipInfo?.level }}</span>
                  <span class="color-[#60B289]">{{ t('person.maxLevelReached') }}</span>
                </template>
                <template v-else>
                  {{ t('person.follow') }}
                  <!-- Siga -->
                  <span class="color-[#FEF64A] mx-[2px]">VIP{{ vipStore.vipInfo?.level + 1
                  }}</span>
                  {{ t('person.stillNeedToBet') }}
                  <!-- Ainda precisa apostar -->
                  {{ numberFormat(remainingBet) }}
                </template>
              </div>
              <!-- <div class="color-[#ffffff] text-[10px] text-center">
                <div>{{ t('person.betRequired') }}</div>
                <div>{{ t('person.needed') }}</div>
              </div> -->
            </div>
            <div class="progress-container w-full h-[14px]">
              <div class="p-[1px] rounded-full progress-box">
                <div class="progress-bar m-[1px] p-[1px]">
                  <div class="progress-fill" :style="{ width: progressPercentage + '%' }"></div>
                  <div class="progress-text whitespace-nowrap">
                    <!-- 根据是否为最高等级显示不同内容 -->
                    <template v-if="isMaxLevel">
                      {{ t('person.maxLevelAchieved') }}
                    </template>
                    <template v-else>
                      {{ numberFormat(vipStore.vipInfo?.bet || 0) }} / {{ numberFormat(nextVipConfig?.advanceBet || 0)
                      }}
                    </template>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="flex-shrink-0 h-full flex items-center px-[10px]">
            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
        </div>

      </div>
      <div class="w-full">
        <div class="person-menu w-full">
          <div class="menu-item" @click="goToRelatorios">
            <img class="menu-icon" :src="getAssetsFile('home/detail.png')" alt="">
            <span class="menu-title">{{ t('person.reports') }}</span>
            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
          <div class="menu-item" @click="goToConvidarCentro">
            <img class="menu-icon" :src="getAssetsFile('home/convidar.png')" alt="">
            <span class="menu-title">{{ t('person.invite') }}</span>
            <span class="menu-desc"></span>
            <!-- 推广员红点 -->
            <RedDot v-if="hasPromoterRewards" class="absolute top-1/2 right-20px" />
            <!-- <div v-if="hasPromoterRewards"
              class="absolute top-1/2 right-20px w-[13px] h-[13px] transform -translate-y-1/2 translate-x-1/4">
              <div class="relative w-full h-full text-white text-white text-[8px] flex items-center justify-center">
                <img :src="getAssetsFile('home/messageUnreadIcon.png')" alt=""
                  class="w-[14px] h-[15px] absolute left-1px top-1px" />
              </div>
            </div> -->

            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
          <div class="menu-item" @click="goToResgate">
            <img class="menu-icon" :src="getAssetsFile('home/resgate.png')" alt="">
            <span class="menu-title">{{ t('person.redemptionCode') }}</span>
            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
          <div class="menu-item" @click="goToMensagens(0)">
            <img class="menu-icon" :src="getAssetsFile('home/ssdas.png')" alt="">
            <span class="menu-title">{{ t('person.support') }}</span>
            <RedDot v-if="messageStore.count > 0" class="absolute top-1/2 right-20px" :count="messageStore.count"
              :big="messageStore.count > 10" />

            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
          <div class="menu-item" @click="goToSecurity">
            <img class="menu-icon" :src="getAssetsFile('home/security.png')" alt="">
            <span class="menu-title">{{ t('person.securityCenter') }}</span>
            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
          <div class="menu-item" @click="handleLogoutClick">
            <img class="menu-icon" :src="getAssetsFile('home/logout.png')" alt="">
            <span class="menu-title">{{ t('person.logout') }}</span>
            <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 头像选择弹窗（使用vant3的van-popup） -->
  <van-popup v-model:show="showAvatarModal"
    :style="{ height: '100%', width: '100%', padding: '0 0 16px 0', background: 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }"
    teleport="body">
    <div class="avatar-box relative flex flex-col justify-between">
      <div>
        <!-- 顶部栏 -->
        <div class="avatar-popup-header">

          <span class="avatar-popup-title">
            {{
              t('person.changeAvatar').toUpperCase()
            }}</span>
          <!-- <span class="avatar-popup-placeholder"></span> -->
        </div>
        <!-- 性别选择 -->
        <div class="avatar-gender-select">
          <span class="gender-item" :class="{ active: avatarGender === 'M' }" @click="avatarGender = 'M'">{{
            t('person.male')
          }}</span>
          <span class="gender-item" :class="{ active: avatarGender === 'F' }" @click="avatarGender = 'F'">{{
            t('person.female') }}</span>
        </div>
        <div class="gender-underline">
          <div class="underline" :style="{ left: avatarGender === 'M' ? '0%' : '50%' }"></div>
        </div>
        <!-- 头像列表 -->
        <div class="avatar-list">
          <div v-for="(item, idx) in filteredAvatars" :key="item.id" class="avatar-item"
            :class="{ selected: selectedAvatar === item.path }" @click="selectedAvatar = item.path">
            <img :src="VITE_IMG_URL + item.path" :alt="item.id" class="avatar-img">
          </div>
        </div>
      </div>
      <!-- 确认按钮 -->
      <div class="flex justify-center items-center w-full h-1/10">
        <Button type="medium" class="avatar-confirm-btn" @click="confirmAvatar">{{ t('person.confirm') }}</Button>
      </div>
    </div>
  </van-popup>
  <!-- 退出弹窗遮罩 -->
  <div v-if="showLogoutModal" class="modal-mask" @click.self="showLogoutModal = false">
    <div class="logout-modal">
      <div class="logout-title h-[40px] flex relative">
        <div class="w-full text-line-1-#004A36">
          {{ t('person.logout') }}
        </div>
        <div @click="showLogoutModal = false"
          class="w-[28px] h-[28px] absolute right-[5px] top-2/5 transform -translate-y-1/2">
          <Button type="close" class="!w-[28px] !h-[28px]" />
          <!-- <img :src="getAssetsFile('home/logoutPopClose.png')" alt="" class="w-[28px] h-[28px] cursor-pointer"> -->
        </div>
      </div>
      <div class="px-[7px] ">
        <div class="logout-tip bg-[rgba(2,71,59,.65)] rounded-[5px] h-[107px] flex items-center justify-center">{{
          t('person.logoutConfirm') }}</div>
      </div>

      <div class="logout-btns">
        <Button type="default" class="w-[126px] h-[43px] text-line-1.5-#084500" @click="showLogoutModal = false">{{
          t('person.cancel')
        }}</Button>
        <Button type="default" :warning="true" class="w-[126px] h-[43px] text-line-1.5-#3A1F00" @click="handleLogout">{{
          t('person.logout')
        }}</Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RedDot } from "@/components/RedDot";
import { Border } from "@/components/Border"
import { Button } from "@/components/Button"
import { useUserStore } from '@/stores'
import * as GameApi from '@/api/game'
import { useRouter } from 'vue-router'
import { onMounted, ref, computed, watch, onBeforeUnmount } from 'vue'
import { useClipboard } from '@vueuse/core'
import { useVipStore } from '@/stores/modules/vip'
import { useMessageStore } from '@/stores/modules/message'
import { useI18n } from 'vue-i18n'
import {
  trackProfileClickDepositButton, trackProfileClickInviteButton,
  trackProfileClickReportsButton, trackProfileClickRedemptionCodeButton, trackProfileClickSecurityCenterButton,
  trackProfileClickVipButton, trackProfileClickWithdrawButton
} from '@/utils/firebase-analytics'
import {
  trackProfileClickSupportButton,
  trackProfileClickLogoutButton,
  trackProfileClickInboxButton
} from '@/utils/firebase-analytics';
import { numberFormat } from '@/utils/formatter'
const { t } = useI18n()
const VITE_symbol = import.meta.env.VITE_SYMBOL
const router = useRouter()
import useUIStore from '@/stores/modules/ui'
import { useActivityStore } from '@/stores/modules/activity'
const userStore = useUserStore()
const vipStore = useVipStore()
const isRefreshing = ref(false)
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL
const showLogoutModal = ref(false)
const showAvatarModal = ref(false)
const showDoubleWallet = ref(false);
const avatarGender = ref('M')
const avatarList = ref<any[]>([])
const selectedAvatar = ref('')
const filteredAvatars = computed(() =>
  avatarList.value.filter(a => {
    // 根据sex字段过滤：1=男性(M)，0=女性(F)
    if (avatarGender.value === 'M') {
      return a.sex === 1
    } else {
      return a.sex === 0
    }
  })
)
const vipInfo = ref<any>({})
// 添加推广员信息状态
const promoterInfo = ref<any>({
  commission: 0,
  profit: 0,
  promoterNum: 0
})
// 数字滚动动画相关
const currentBalance = ref(0)
const targetBalance = ref(0)
const isAnimating = ref(false)
// 计算显示的余额
const displayBalance = computed(() => {
  return numberFormat(currentBalance.value)
})

const IS_DOUBLE_WALLET = import.meta.env?.VITE_WALLET_SWITCH == 'true' ? true : false;
const walletFlag = useStorage('walletFlag', 'cash', sessionStorage);
// 数字滚动动画函数
const animateBalance = (start: number, end: number, duration: number = 1500) => {
  if (isAnimating.value) return

  isAnimating.value = true
  const startTime = Date.now()
  const difference = end - start

  const animate = () => {
    const currentTime = Date.now()
    const elapsed = currentTime - startTime
    const progress = Math.min(elapsed / duration, 1)

    // 使用缓动函数让动画更自然
    const easeOutQuart = 1 - Math.pow(1 - progress, 4)
    currentBalance.value = start + (difference * easeOutQuart)

    if (progress < 1) {
      requestAnimationFrame(animate)
    } else {
      // 确保最终值准确
      currentBalance.value = end
      isAnimating.value = false
    }
  }

  requestAnimationFrame(animate)
}

const cash = computed(() => {
  const walletInfos = userStore.userInfo.userWalletInfos;
  return walletInfos?.find((item: any) => item.currencyId != 3)?.availableAccount || 0;
});

const bonus = computed(() => {
  const walletInfos = userStore.userInfo.userWalletInfos;
  return walletInfos?.find((item: any) => item.currencyId == 3)?.availableAccount || 0;
})

const balance = computed(() => {
  if (walletFlag.value == 'cash') {
    return cash?.value || 0;
  } else {
    return bonus?.value || 0;
  }
})
// 监听钱包余额变化
watch(
  () => balance.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      const newBalance = parseFloat(newValue || '0')
      const oldBalance = parseFloat(oldValue || '0')

      if (newBalance !== oldBalance) {
        // 如果正在动画中，从当前值开始
        const startValue = isAnimating.value ? currentBalance.value : oldBalance
        animateBalance(startValue, newBalance)
      }
    }
  },
  { immediate: true }
)

// 修改计算属性，使用vipStore的数据
const currentVipConfig = computed(() => {
  if (!vipStore.vipData?.configList || !vipStore.vipInfo?.level) {
    return null
  }
  const currentLevel = vipStore.vipInfo.level
  return vipStore.vipData.configList.find(config => config.level === currentLevel)
})

const nextVipConfig = computed(() => {
  console.log('Debug nextVipConfig:', {
    configList: vipStore.vipData?.configList,
    currentLevel: vipStore.vipInfo?.level,
    levelType: typeof vipStore.vipInfo?.level,
    vipData: vipStore.vipData
  })

  // 修改条件判断，允许 level 为 0
  if (!vipStore.vipData?.configList || vipStore.vipInfo?.level === undefined || vipStore.vipInfo?.level === null) {
    console.log('Missing configList or level is undefined/null')
    return null
  }

  const nextLevel = vipStore.vipInfo.level + 1
  console.log('Looking for level:', nextLevel)

  const config = vipStore.vipData.configList.find(config => config.level === nextLevel)
  console.log('Found config:', config)

  return config
})

// 添加判断是否为最高等级的计算属性
const isMaxLevel = computed(() => {
  if (!vipStore.vipData?.configList || vipStore.vipInfo?.level === undefined || vipStore.vipInfo?.level === null) {
    return false
  }

  // 获取所有等级配置，找到最高等级
  const maxLevel = Math.max(...vipStore.vipData.configList.map(config => config.level))
  return vipStore.vipInfo.level >= maxLevel
})

const remainingBet = computed(() => {
  console.log('Debug remainingBet:', {
    nextVipConfig: nextVipConfig.value,
    currentBet: vipStore.vipInfo?.bet,
    level: vipStore.vipInfo?.level,
    levelType: typeof vipStore.vipInfo?.level,
    vipData: vipStore.vipData
  })

  // 如果已经是最高等级，返回0
  if (isMaxLevel.value) {
    console.log('User is at max level')
    return 0
  }

  if (!nextVipConfig.value) {
    console.log('No nextVipConfig found')
    return 0
  }

  // 修改条件判断，允许 bet 为 0
  if (vipStore.vipInfo?.bet === undefined || vipStore.vipInfo?.bet === null) {
    console.log('No current bet found')
    return nextVipConfig.value.advanceBet || 0
  }

  const requiredBet = nextVipConfig.value.advanceBet || 0
  const currentBet = vipStore.vipInfo.bet || 0
  const remaining = Math.max(0, requiredBet - currentBet)

  console.log('Bet calculation:', {
    requiredBet,
    currentBet,
    remaining
  })

  return remaining
})

const progressPercentage = computed(() => {
  // 如果已经是最高等级，显示100%
  if (isMaxLevel.value) {
    return 100
  }

  if (!nextVipConfig.value || !vipStore.vipInfo?.bet) {
    return 0
  }
  const requiredBet = nextVipConfig.value.advanceBet || 0
  const currentBet = vipStore.vipInfo.bet || 0

  if (requiredBet === 0) return 100

  const percentage = (currentBet / requiredBet) * 100
  return Math.min(percentage, 100)
})

const hasVipRewards = computed(() => {
  const drawRewardList = vipStore.vipData.drawRewardList || []
  return drawRewardList.length > 0
})

// 添加推广员红点计算属性
const hasPromoterRewards = computed(() => {
  return promoterInfo.value?.commission > 0
})

const messageStore = useMessageStore()
const uiStore = useUIStore()
const activityStore = useActivityStore()

onMounted(async () => {
  // 使用getUserAvatar接口获取所有头像
  const res = await GameApi.getUserAvatar()
  avatarList.value = res.data || []
  // 默认选中当前头像
  selectedAvatar.value = userStore.userInfo.avatar

  // 初始化余额显示
  const initialBalance = parseFloat(userStore.userInfo.userWalletInfos?.[0]?.availableAccount || '0')
  currentBalance.value = initialBalance

  // 调用getUserVipInfo接口
  try {
    const vipInfoRes = await GameApi.getUserVipInfo()
    console.log('getUserVipInfo接口调用成功:', vipInfoRes.data)

    // 重新赋值给vipStore
    if (vipInfoRes.data) {
      const data = vipInfoRes.data
      // 根据当前level找到对应的配置
      const currentVip = data.configList?.find(config => config.level === data.level)
      if (currentVip) {
        // 构建vipInfo，包含currentVip字段供VIP页面使用
        vipStore.vipInfo = {
          level: data.level,
          bet: data.bet,
          recharge: data.recharge,
          currentVip: {
            icon: currentVip.icon, // 等级头像
            conditions: [
              { value: currentVip.advanceRecharge || 0 }, // 充值条件
              { value: currentVip.advanceBet || 0 }       // 投注条件
            ]
          }
        }
      }

      // vipData包含完整的配置数据
      vipStore.vipData = data
    }
  } catch (error) {
    console.error('getUserVipInfo接口调用失败:', error)
  }

  // 加载VIP数据 - 使用vipStore的方式
  await vipStore.loadVipData()

  // 获取推广员信息
  try {
    const promoterRes = await GameApi.userpromoterInfo()
    if (promoterRes && promoterRes.data) {
      promoterInfo.value = promoterRes.data
    }
  } catch (error) {
    console.error('获取推广员信息失败:', error)
  }

  // 主动获取消息数量，确保红点能立即显示
  try {
    const msgRes = await GameApi.siteMsglist({
      pageNo: 1,
      pageSize: 50,
      msgType: ''
    })
    const unreadCount = msgRes.data.list?.filter(item => !item.read).length || 0
    messageStore.setCount(unreadCount)
  } catch (error) {
    console.error('获取消息数量失败:', error)
  }

  const socket = window.$socket
  if (socket) {
    socket.on('red_point_notice', (data) => {
      const count = data?.redPointMap?.[1] || 0
      messageStore.setCount(count)
    })

    // 监听用户余额变化事件
    socket.on('user_amount_change_notice', (info) => {
      if (!info) return

      // 处理 { code: 0, data: ... } 格式
      let walletData = info
      if (info.code === 0 && info.data) {
        walletData = info.data
      }

      // 如果walletData是数组，说明包含多个钱包信息，需要合并更新
      if (Array.isArray(walletData)) {
        // 遍历数组，更新对应的钱包
        walletData.forEach((walletItem: any) => {
          if (walletItem && walletItem.currencyId !== undefined && walletItem.availableAccount !== undefined) {
            // 找到对应的钱包并更新
            const walletInfos = userStore.userInfo.userWalletInfos || []
            const existingIndex = walletInfos.findIndex((item: any) => item.currencyId === walletItem.currencyId)

            if (existingIndex >= 0) {
              // 更新已存在的钱包
              walletInfos[existingIndex] = {
                ...walletInfos[existingIndex],
                availableAccount: walletItem.availableAccount
              }
            } else {
              // 添加新钱包
              walletInfos.push(walletItem)
            }

            // 更新store
            userStore.userInfo.userWalletInfos = walletInfos
          }
        })
      }
      // 如果walletData是对象且包含currencyId，说明是单个钱包信息
      else if (walletData && typeof walletData === 'object' && walletData.currencyId !== undefined && walletData.availableAccount !== undefined) {
        // 找到对应的钱包并更新
        const walletInfos = userStore.userInfo.userWalletInfos || []
        const existingIndex = walletInfos.findIndex((item: any) => item.currencyId === walletData.currencyId)

        if (existingIndex >= 0) {
          // 更新已存在的钱包
          walletInfos[existingIndex] = {
            ...walletInfos[existingIndex],
            availableAccount: walletData.availableAccount
          }
          userStore.userInfo.userWalletInfos = walletInfos
        } else {
          // 如果没有找到，添加新钱包
          walletInfos.push(walletData)
          userStore.userInfo.userWalletInfos = walletInfos
        }
      }
      // 如果walletData只有availableAccount没有currencyId，重新获取完整用户信息
      // 避免错误更新到CASH钱包
      else if (walletData && walletData.availableAccount !== undefined && walletData.currencyId === undefined) {
        // 没有currencyId时，重新获取完整用户信息，确保数据准确
        console.log('[个人中心] Socket余额变化事件缺少currencyId，重新获取用户信息')
        userStore.info().catch(err => {
          console.error('[个人中心] 重新获取用户信息失败:', err)
        })
      }
    })
  }
})

onBeforeUnmount(() => {
  if (window.$socket && window.$socket.off) {
    window.$socket.off('red_point_notice')
    window.$socket.off('user_amount_change_notice')
  }
})

async function handleRefresh() {
  if (isRefreshing.value) return
  isRefreshing.value = true
  // 刷新钱包余额
  await userStore.info()
  setTimeout(() => {
    isRefreshing.value = false
  }, 1000) // 动画持续1秒
}
const handleWithdraw = () => {
  trackProfileClickWithdrawButton()
  // 设置来源标记
  sessionStorage.setItem('fromPerson', 'true')
  router.push('/wallet')
}
const handleDeposit = () => {
  trackProfileClickDepositButton()
  // 设置来源标记
  sessionStorage.setItem('fromPerson', 'true')
  router.push('/Deposito')
}
function handleLogoutClick() {
  trackProfileClickLogoutButton()
  showLogoutModal.value = true
}
function handleLogout() {
  // 立即设置退出登录标记，防止弹窗闪烁
  sessionStorage.setItem('is_logging_out', 'true')

  // 保存记住的账号密码
  const rememberedCredentials = localStorage.getItem('rememberedCredentials')

  // 获取当前用户的稳定ID
  const stableUserId = localStorage.getItem('stable_user_id')

  // 保存所有弹窗相关的本地存储，包括stable_user_id
  const popupRelatedData = {}
  const keys = Object.keys(localStorage)
  keys.forEach(key => {
    if (key.includes('popup_') || key === 'stable_user_id') {
      // 保留所有弹窗状态，包括：
      // - popup_daily_* (每日一次) - 保留，基于日期和用户
      // - popup_once_* (只弹一次) - 保留，基于用户
      // - popup_no_reminder_* (今日不再弹出) - 保留，基于用户和日期
      // - popup_activity_* (活动相关) - 保留
      // - stable_user_id (稳定用户ID) - 保留

      // 只清除登录相关的状态：
      // - popup_login_visit_* (登录后访问状态) - 让用户重新登录时能再次看到 Case 1 弹窗
      // - popup_login_timestamp_* (登录时间戳)

      if (!key.includes('popup_login_visit_') &&
        !key.includes('popup_login_timestamp_')) {
        popupRelatedData[key] = localStorage.getItem(key)
      }
    }
  })

  // 清除sessionStorage（但保留 is_logging_out 标记）
  const isLoggingOut = sessionStorage.getItem('is_logging_out')

  // 在清除sessionStorage之前，先清理用户相关的缓存
  console.log('退出登录，清理用户相关缓存')
  const keysToRemove = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i)
    if (key && (key.includes('turntable_completed_') || key.includes('skip_turntable_'))) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach(key => {
    sessionStorage.removeItem(key)
    console.log('清理缓存:', key)
  })

  sessionStorage.clear()
  sessionStorage.setItem('is_logging_out', isLoggingOut)

  // 清除活动红点状态
  uiStore.setActivityBadge('vip', false)
  uiStore.setActivityBadge('rebate', false)
  uiStore.setActivityBadge('eventos', false)

  // 重置活动页面的activeTab为0（第一页）
  uiStore.setActivityActiveTab(0)

  // 清除活动store数据
  activityStore.clearFinancialData()

  // 关闭弹窗
  showLogoutModal.value = false

  // 先跳转到首页
  router.replace('/')

  // 延迟执行登出，确保先跳转到首页
  setTimeout(async () => {
    // 执行登出
    await userStore.logout?.()

    // 在logout执行完后，恢复弹窗相关的本地存储
    setTimeout(() => {
      // 恢复记住的账号密码
      if (rememberedCredentials) {
        localStorage.setItem('rememberedCredentials', rememberedCredentials)
      }

      // 恢复弹窗相关的本地存储（包括stable_user_id）
      Object.keys(popupRelatedData).forEach(key => {
        localStorage.setItem(key, popupRelatedData[key])
      })

      // 清除退出登录标记，允许弹窗检查
      sessionStorage.removeItem('is_logging_out')
      // 退出登录后刷新页面，就像手动刷新一样
      window.location.reload()
      console.log('GlobalPopup: Logout completed, popup states restored (including no_reminder)')
    }, 100)
  }, 100)
}
function goToResgate() {
  trackProfileClickRedemptionCodeButton()
  router.push({ name: 'activity', query: { tab: 'codigo' } })
}
function goToSecurity() {
  trackProfileClickSecurityCenterButton()
  router.push({ name: 'security' })
}
function goToMensagens(activeTab: number) {
  if (activeTab === 1) {
    trackProfileClickInboxButton()
  } else {
    trackProfileClickSupportButton()
  }
  router.push({ name: 'mensagens', query: { activeTab } })
}
function goToVip() {
  trackProfileClickVipButton()
  // 设置来源标记
  sessionStorage.setItem('fromPerson', 'true')
  router.push({ name: 'activity', query: { tab: 'vip' } })
}
function goToRelatorios() {
  trackProfileClickReportsButton()
  router.push({ name: 'relatorios' })
}
const goToConvidarCentro = () => {
  trackProfileClickInviteButton()
  router.push({ name: 'ConvidarCentro' })
}
function goToBonusRecord() {

  router.push({ name: 'bonusRecord' })
}

const { copy: copyToClipboard } = useClipboard()
function copyUserId(userId: string) {
  copyToClipboard(userId)
    ; (window as any).$toast(t('person.copySuccess'))
}

function confirmAvatar() {
  if (!selectedAvatar.value) return
  const selectedAvatarItem = avatarList.value.find(item => item.path === selectedAvatar.value)
  if (selectedAvatarItem) {
    // 直接传ID数字，不传对象
    GameApi.updateUserAvatar(selectedAvatarItem.id).then(() => {
      userStore.info()
      showAvatarModal.value = false
    })
  }
}
</script>

<style lang="scss" scoped>
.person-content {
  background: getPath('person/bj_bonus.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
}

:deep(.van-popover--dark .van-popover__content) {
  background: transparent !important;
}

.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #60B289 !important;
  /* 添加!important确保优先级 */
  transition: transform 0.2s;
}

:root {
  --van-popover-dark-background: transparent !important;
}

.selectLangContainer {
  background: getPath("home/selectLangBg.png") no-repeat;
  background-size: 100% 100%;
  --van-popover-dark-background: transparent !important;
}

:deep(.van-popover .van-popover__arrow) {
  display: none;
}

.avatar-box {
  background: getPath('person/avatarPopBg.png') no-repeat;
  background-size: 100% 100%;
  height: 80%;
  max-height: 560px;
  width: 100%;
  padding: 31% 7% 3% 7%;
}

.person {
  min-height: 100vh;
  background: getPath('person/personBg.png') no-repeat;
  background-size: 100% 100%;

}

.avatar {
  background: getPath('person/avatarBg.png') no-repeat center center;
  background-size: 100% 100%;

}

.personheader {
  margin-top: 20px;
  border-radius: 8px;
  // padding: 15px 15px;
}

.rotate-animation {
  animation: rotate 1s linear;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.rotate-animation-reverse {
  animation: rotate-reverse 600ms linear;
}

@keyframes rotate-reverse {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}

.tians {
  height: 39px;
  line-height: 39px;
  background: linear-gradient(180deg, #13C769 0%, #1C9755 100%);
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;

}

.deposts {
  height: 39px;
  line-height: 39px;
  background: linear-gradient(0deg, #E99726 0%, #F7C071 100%);
  box-shadow: 1px 1px 2px 0px rgba(21, 76, 55, 0.32);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.vipstyle {
  height: 93px;
  background: getPath('vip/vipHeaderBg.png') no-repeat center center;
  background-size: 100% 100%;
  border-radius: 8px;
  margin-top: 13px;
  padding: 25px 14px;
  position: relative;
  /* 添加相对定位 */
}

/* VIP红点样式 */
.vip-badge-dot {
  position: absolute;
  top: 8px;
  right: 14px;
  width: 12px;
  height: 12px;
  background: #FF3B30;
  /* 统一为指定红色 */
  border-radius: 50%;
  z-index: 10;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.promess {
  height: 16px;
  background: #1F6749;
  border-radius: 8px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  font-size: 10px;
  margin-left: 8px;
  flex: 1;
}

/* 新增进度条样式 */
.progress-container {
  // margin-left: 8px;
  // flex: 1;
}

.progress-box {
  background: linear-gradient(0deg, #FFE4A5, #D1A74A);
}

.progress-bar {
  height: 15px;
  background: linear-gradient(0deg, #70530A 0%, #240202 70%);

  border-radius: 10px;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, rgba(246, 211, 98, 0.52) 52%, #FFFCE8 100%);

  border-radius: 10px;
  transition: width 0.3s ease;
  position: relative;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.2) 50%, transparent 100%);

}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.progress-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #FFFEE0;
  font-size: 10px;
  text-align: center;
  line-height: 1;
  z-index: 2;
  // font-weight: 500;
  // text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.person-menu {

  border-radius: 8px;
  padding: 2px 6px 0 6px;
  margin-top: 13px;
}

.menu-item {
  display: flex;
  align-items: center;
  height: 48px;
  position: relative;
  font-size: 11px;
  color: #fff;
}

.menu-item:last-child {
  border-bottom: none;
}

.menu-icon {
  width: 28px;
  height: 28px;
  margin-right: 12px;
  flex-shrink: 0;
}

.menu-title {
  flex: 1;
  font-size: 14px;
  color: #fff;
}

.menu-desc {
  font-size: 9px;
  color: #FFFFFF;
  margin-right: 10px;
}

.menu-badge {
  background: #FF3B30;
  color: #fff;
  font-size: 9px;
  border-radius: 50%;
  height: 13px;
  min-width: 13px;
  line-height: 13px;
  text-align: center;
  margin-right: 10px;
  margin-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  padding: 0 2px;
}

/* 小屏手机 */
@media (max-width: 480px) {
  .menu-badge {
    background: #FF3B30;
    color: #fff;
    font-size: 9px;
    padding-right: 1px;
    border-radius: 50%;
    height: 15px;
    line-height: 15px;
    text-align: center;
    margin-right: 10px;
    display: inline-block;
    text-align: center;
    min-width: 15px;
    text-align: center;
    margin-top: 2px;
  }
}

/* 中等手机屏幕 */
@media (max-width: 568px) {
  .menu-badge {
    background: #FF3B30;
    color: #fff;
    font-size: 9px;
    padding-right: 1px;
    border-radius: 50%;
    height: 15px;
    line-height: 15px;
    text-align: center;
    margin-right: 10px;
    display: inline-block;
    text-align: center;
    min-width: 15px;
    text-align: center;
    margin-top: 2px;
  }
}

/* 大屏手机 */
@media (max-width: 768px) {
  .menu-badge {
    background: #FF3B30;
    color: #fff;
    font-size: 9px;
    padding-right: 1px;
    border-radius: 50%;
    height: 15px;
    line-height: 15px;
    text-align: center;
    margin-right: 10px;
    display: inline-block;
    text-align: center;
    min-width: 15px;
    text-align: center;
    margin-top: 2px;
  }
}

.menu-arrow {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #fff;
  opacity: 0.5;
  margin-left: auto;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.logout-modal {
  background: getPath('home/logoutPopBg.png') no-repeat;
  background-size: 100% calc(100% + 2px);
  border-radius: 10px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
  padding: 5px;
  width: 90%;
  max-width: 333px;
  height: 234px;
  text-align: center;
}

.logout-title {
  font-size: 21px;
  color: #FFFC11;
  font-weight: bolder;
  // margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;

}

.logout-tip {
  color: #95DBCA;
  font-size: 13px;
  margin-bottom: 15px;
}

.logout-btns {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  padding: 0 30px 0 30px;
}

// .btn-cancel,
// .btn-logout {
//   flex: 1;
//   height: 44px;
//   border-radius: 6px;
//   font-size: 13px;
//   font-weight: 700;
//   border: none;
//   outline: none;
//   cursor: pointer;
//   transition: filter 0.2s;
// }

.btn-cancel {
  background: #1B6B4B;
  box-shadow: 0 1.2px 1px rgba(10, 34, 25, 0.3);
  color: #fff;
}

.btn-logout {
  background: linear-gradient(180deg, #13C869 0%, #1C9A56 100%);
  color: #fff;
}

.btn-cancel:active,
.btn-logout:active {
  filter: brightness(0.95);
}

.avatar-modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-modal {
  background: #18553A;
  border-radius: 16px;
  width: 90vw;
  max-width: 400px;
  padding: 18px 16px 20px 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.18);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.avatar-modal-header {
  height: 32px;
}

.avatar-modal-title {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  flex: 1;
}

.avatar-popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 0 12px;
  background: transparent;
}

.avatar-popup-close {
  font-size: 13px;
  color: #fff;
  width: 32px;
  text-align: left;
  cursor: pointer;
  user-select: none;
}

.avatar-popup-title {
  flex: 1;
  text-align: center;
  background: linear-gradient(180deg, #FEFEB4 0%, #FFEE7B 47.509765625%, #E7A825 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 1px;
}

.avatar-popup-placeholder {
  width: 32px;
}

.avatar-popup-divider {
  width: 100%;
  height: 2px;
  background: #117a5a;
  margin-bottom: 2px;
}

.avatar-gender-select {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* 改为space-between，让M和F分别靠左右两边 */
  font-size: 14px;
  margin-top: 6px;
  margin-bottom: 6px;
  position: relative;
  padding: 0 60px;
  /* 增加左右间距，让M和F更靠两边 */
}

.gender-item {
  color: #50B388;
  /* 未选中状态颜色 */
  padding: 0 20px;
  /* 减少内部padding */
  cursor: pointer;
  transition: color 0.2s;
  font-size: 14px;
  position: relative;
  text-align: center;
  /* 让文字在各自的区域内居中 */
}

.gender-item.active {
  color: #fff;
  /* 选中状态白色 */
}

.gender-divider {
  width: 1px;
  height: 18px;
  background: #3cc35f;
  margin: 0 10px;
  /* 减少分隔线间距 */
}

.gender-underline {
  position: relative;
  height: 3px;
  width: 100%;
  margin-bottom: 10px;
  background: #006849;
  /* 默认横线背景色 */
}

.underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 50%;
  height: 2px;
  background: #009F76;
  /* 选中状态白色下划线 */
  border-radius: 2px;
  transition: left 0.2s;
}

.avatar-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px 6px;
  padding: 6px 6px;
  margin-bottom: 18px;
  max-height: 400px;
  overflow-y: auto;
}

.avatar-item {
  width: 100%;
  aspect-ratio: 1/1;
  background: #117a5a;
  border-radius: 8px;
  width: 66px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border 0.2s, transform 0.2s;
}

.avatar-item.selected {
  transform: scale(1.08);
  z-index: 2;
}

.avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

.avatar-confirm-btn {
  width: 92%;
  margin: 0 auto;
  display: block;
  height: 38px;
  background: linear-gradient(180deg, #13C869 0%, #1C9A56 100%);
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border: none;
  border-radius: 20px;
  margin-top: 8px;
  cursor: pointer;
  transition: filter 0.2s;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.3);
  /* 添加下边框阴影 */
  letter-spacing: 1px;
}

.avatar-confirm-btn:active {
  filter: brightness(0.95);
}

/* 邮箱红点样式 */
.email-badge-dot {
  position: absolute;
  top: -5px;
  right: -8px;
  min-width: 15px;
  height: 15px;
  background: #FF3B30;
  border-radius: 50%;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 9px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 0 2px;
}
</style>
<route lang="json5">
    {
      name: 'person',
      meta: {
        title: '个人中心',
        i18n: 'menus.person'
      },
    }
</route>
